import React from 'react'
import TimeOffLeaveType from './TimeOffLeaveType'
import TimeOffWorksheet from './TimeOffWorksheet'

class TimeOffLeaveTypes extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      time_off_types: props.data,
      show_timeoff_worksheet: this.props.show_timeoff_worksheet
    }
  }

  onHelpfulCheck (data) {
    let  benefits = this.state.time_off_types
    benefits.forEach((benefit) => {
      if (data.item_id === benefit.lpb_id) {
        benefit.item.helpful = data.helpful
      }
    })
    this.setState({
      time_off_types: benefits
    })
  }

  onTimeOffTypeChange (data) {
    this.setState(prevState => {
      return{
        time_off_types: prevState.time_off_types.map((time_off_types) => {
          return time_off_types.id === data.id ? data : time_off_types
        })
      }
    })
  }

  renderTimeOffWorksheet(){
    return(
      <TimeOffWorksheet
        data={this.state.time_off_types}
        accrued_time_preservable={this.props.accrued_time_preservable}
      />
    )
  }

  renderTimeOffLeaveType (data, index){
    return(
      <TimeOffLeaveType
        key={ index }
        data={ data }
        onTimeOffTypeChange={ this.onTimeOffTypeChange.bind(this) }
        onHelpfulCheck={ this.onHelpfulCheck.bind(this) }
      /> 
    )
  } 

  render () {
    const timeOffLeaveTypes = this.state.time_off_types
    const { header } = this.props
    return (
      <div id='time-off-types'>
        <h3> { header } </h3>
        <div className='row'>
          {
            this.state.show_timeoff_worksheet ?
              this.renderTimeOffWorksheet() :  
              timeOffLeaveTypes.map((data, index) => this.renderTimeOffLeaveType(data, index))  
          }
        </div>
      </div>
    )
  }
}

export default TimeOffLeaveTypes
